import React from "react";
import { CheckCircle2Icon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { insideItems, MOCKUP_IMAGE } from "../../data/offer";
export function Hero() {
  return <header className="w-full bg-white" data-id="element-212" data-mp="cxxmhie9bp6m">
      <div className="bg-navy-900 px-4 py-2.5 text-center text-xs font-extrabold uppercase tracking-[0.12em] text-gold sm:text-sm" data-id="element-213" data-mp="hvgzyg34rxxi">
        Special Launch Offer · Complete Collection for only $27
      </div>

      <div className="mx-auto grid max-w-6xl gap-8 px-5 pb-16 pt-10 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-12 lg:pb-24" data-id="element-214" data-mp="quuc5gin30lx">
        <div className="text-center lg:text-left" data-id="element-215" data-mp="vn45z7mvkkth">
          <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand sm:text-sm" data-id="element-216" data-mp="10loyekvvy07d">
            Self-Ligating Orthodontics Blueprint™ · By Dr. Valeria Montes
          </p>
          <h1 className="mt-4 text-[30px] font-black leading-[1.12] tracking-tight text-ink sm:text-5xl lg:text-[52px]" data-id="element-217" data-mp="1ajd3a3n7go39">
            Stop Guessing Your Next Step in Self-Ligating Orthodontics —{" "}
            <span className="text-brand" data-id="element-218" data-mp="4o6mpojyd38k">Build a Structured Treatment Roadmap in 6 Clinical Steps.</span>
          </h1>

          <img src={MOCKUP_IMAGE} alt="Self-Ligating Orthodontics Blueprint: 6 volumes and 5 bonus books by Dr. Valeria Montes" className="mx-auto mt-8 w-full max-w-md lg:hidden" data-id="element-219" data-mp="3vw2borgruoos" />

          <p className="mt-6 text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-220" data-mp="sdit6gnwax76">
            Understand the biomechanics behind self-ligating bracket systems, organize your treatment decisions, and
            approach every phase with a clearer clinical framework.
          </p>
          <p className="mt-3 text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-221" data-mp="em48m5ecany0">
            A visual educational system for orthodontists and dental professionals who want to connect{" "}
            <strong className="font-bold text-ink" data-id="element-222" data-mp="16d0kp3sksok8">
              diagnosis, bracket mechanics, archwire selection, anchorage control, treatment sequencing, and finishing.
            </strong>
          </p>

          <div className="mt-8 rounded-2xl bg-surface p-5 text-left" data-id="element-223" data-mp="35jp738feg530">
            <p className="text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-224" data-mp="2qwnngzntp2b8">Inside, you'll receive:</p>
            <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-225" data-mp="2vufgjx07euh0">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold text-ink" data-id="element-226" data-mp="2hueb048zuyv7">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-227" data-mp="2mvaguncwov39" />
                  {item}
                </li>)}
            </ul>
          </div>

          <p className="mt-6 text-base font-bold italic text-ink" data-id="element-228" data-mp="2cx4ek4n6tmxv">
            From understanding self-ligating brackets to understanding the clinical decisions behind their use.
          </p>

          <div className="mt-6 flex flex-col items-center gap-3 lg:items-start" data-id="element-229" data-mp="b3wygszr31ax">
            <CtaButton id="first-cta" label="Get the Self-Ligating Blueprint™" data-id="element-230" data-mp="1vm8y8r9dmbbv" />
            <p className="text-xs font-medium text-ink-muted sm:text-sm" data-id="element-231" data-mp="1qo7ee444m7zc">
              Immediate Digital Access · One-Time Payment of $27 USD · Lifetime Access
            </p>
            <p className="flex items-center gap-1.5 text-xs font-semibold text-success sm:text-sm" data-id="element-232" data-mp="25en2bqnxfu17">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-233" data-mp="20kagj9yza6ma" />
              7-Day Satisfaction Guarantee — subject to the published refund policy.
            </p>
          </div>

          <div className="mt-8 rounded-3xl bg-navy-900 p-5 text-center sm:p-6" data-id="element-234" data-mp="2adzoe96z4x2q">
            <p className="text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-235" data-mp="2ob657y850lpb">Special Launch Offer</p>
            <div className="mt-4" data-id="element-236" data-mp="2jdeayxk0snhy">
              <Countdown tone="dark" data-id="element-237" data-mp="txewr21jo7vg" />
            </div>
            <p className="mt-5 text-lg font-black text-white" data-id="element-238" data-mp="ty6qs8fhtxjm">
              Special Introductory Price — <span className="text-gold" data-id="element-239" data-mp="p04z4z404pwj">$27 USD</span>
            </p>
            <p className="text-sm text-white/70" data-id="element-240" data-mp="qgiqrqkbbv00">One payment. No subscriptions.</p>
          </div>
        </div>

        <div className="hidden lg:block" data-id="element-241" data-mp="vdsnlra178xv">
          <img src={MOCKUP_IMAGE} alt="Self-Ligating Orthodontics Blueprint: 6 volumes and 5 bonus books by Dr. Valeria Montes" className="w-full" data-id="element-242" data-mp="vgnadpgip5ug" />
        </div>
      </div>
    </header>;
}